import { useEffect, useRef, useState } from 'react'
import { ProcessingStep } from 'api/clients/ChatClient'
import { Text } from 'blaze-ui/Text/Text'
import { Check02 } from 'blaze-ui/icons/16/Check02'
import Styles from './ProcessingSteps.module.scss'

interface ProcessingStepsProps {
  steps: ProcessingStep[]
  estimatedMinutes?: number
}

const formatElapsed = (seconds: number): string => {
  const mins = Math.floor(seconds / 60)
  const secs = seconds % 60
  return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`
}

const StepTimer = ({ estimatedMinutes = 2 }: { estimatedMinutes?: number }) => {
  const startTimeRef = useRef(Date.now())
  const [elapsed, setElapsed] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setElapsed(Math.floor((Date.now() - startTimeRef.current) / 1000))
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  return (
    <span className={Styles.timer}>
      {formatElapsed(elapsed)} / {estimatedMinutes} m
    </span>
  )
}

export const ProcessingSteps = ({ steps, estimatedMinutes = 2 }: ProcessingStepsProps) => {
  return (
    <div className={Styles.stepsContainer}>
      {steps.map((step) => (
        <div key={step.name} className={Styles.step}>
          <div className={Styles.stepRow}>
            <div className={Styles.stepIcon}>
              {step.status === 'completed' && (
                <div className={Styles.completedIcon}>
                  <Check02 color="white" size={10} />
                </div>
              )}
              {step.status === 'in_progress' && <div className={Styles.pendingIcon} />}
            </div>
            <Text variant="secondary" color="var(--dark-60)">
              {step.name}
            </Text>
          </div>
          {step.status === 'in_progress' && (
            <div className={Styles.stepMeta}>
              <Text variant="metadata" color="var(--dark-40)">
                Thinking...
              </Text>
              <Text variant="metadata" color="var(--dark-40)">
                <StepTimer estimatedMinutes={estimatedMinutes} />
              </Text>
            </div>
          )}
        </div>
      ))}
    </div>
  )
}
